import { FooterContainer } from './styled';
export function MenuFooter(props) {
    const { children, sticky = true, className, withoutPadding } = props;
    return (<FooterContainer $sticky={sticky} $withoutPadding={withoutPadding} className={className}>
      {children}
    </FooterContainer>);
}
